import { DOWNLOAD_DRAFT_RESOLUTION } from "..";
import { apiInstance } from "../config/apiInstance";
import { AxiosResponse } from "axios";

export type DownloadDraftResolutionRequest = {
  consecutive: string;
};

export const downloadDraftResolution = async (
  data: DownloadDraftResolutionRequest,
): Promise<AxiosResponse<Blob>> => {
  const response = await apiInstance.post<Blob>(DOWNLOAD_DRAFT_RESOLUTION, data, {
    responseType: "blob",
    timeout: 0,
    headers: {
      "X-Timezone-Id": "America/Bogota",
      "Accept-Language": "es-CO",
    },
  });

  return response;
};
